// 全局业务组件
import thsTitle from '@/components/title'
import thsAttribute from '@/components/attribute'
import thsAbstract from '@/components/abstract'
import thsContent from '@/components/content'
import thsAdditional from '@/components/additional'
import thsTagInfo from '@/components/tags'
import thsInteract from '@/components/interact'
import thsComment from '@/components/comment'
import thsDisclaimer from '@/components/disclaimer'
import brokerContent from '@/components/brokerContent'
import brokerDisclaimer from '@/components/brokerDisclaimer'


const components = {
    thsTitle,
    thsAttribute,
    thsAbstract,
    thsContent,
    thsAdditional,
    thsTagInfo,
    thsInteract,
    thsComment,
    thsDisclaimer,
    brokerContent,
    brokerDisclaimer
}

Object.keys(components).forEach(ele => {
    components[ele].install = function(Vue, options) {
        Vue.component(ele, Vue.extend( components[ele]))
    }
})
export default components